import { GET_MAGAZINES_START } from "../../types";

export const magazines = (payload) => ({
  type: GET_MAGAZINES_START,
  payload,
});
